<script lang='ts'>
   import {afterUpdate, onMount} from 'svelte';
   import Splide from '@splidejs/splide';
   // import '@splidejs/splide/dist/css/splide-core.min.css';
   import '@splidejs/splide/dist/css/splide.min.css';
   // import '@splidejs/splide/dist/css/themes/splide-sea-green.min.css';

   export let images: string[] = null;
   export let name:string = 'splide';
   export let imageCallback = Function;
   export let triggerCount = 1;

   onMount(() => {
      new Splide(`.${name}`, {
         type   : 'slide',
         perPage: 1,
         rewind: true,
         arrows: images.length > 1,
         classes: {
            arrows: 'splide__arrows custom-arrows',
            arrow : 'splide__arrow custom-arrow',
            prev  : 'splide__arrow--prev custom-prev',
            next  : 'splide__arrow--next custom-next',
         },
         breakpoints: {
            768: {
               perPage: 1,
               fixedHeight: '30vh'
            }
         },
         fixedHeight: 500,
         cover: false,
         lazyLoad: 'nearby',
         preloadPages: 3
      }).mount();
   });






</script>

<div class="image-slider-box">
   <div class={`${name}`} style="max-height: 550px;overflow: hidden;padding-bottom: 50px">
      <div class='splide__track'>
         <ul class='splide__list'>
            {#each images as image}
               <li class='splide__slide' on:click={() => imageCallback(image)}>
                  <img data-splide-lazy={image} alt=''>
               </li>
            {/each}
         </ul>
      </div>
   </div>
</div>


<style>

    .splide__slide img {
        width: 100%;
        height: 100%;
    }

    :global(.splide__pagination) {
       /*bottom: -45px !important;*/
    }

    :global(.splide__pagination__page) {
       background: #686868 !important;
       border-radius: 0px !important;
       margin: 5px !important;

    }

    :global(.splide__pagination__page.is-active) {
       background: black !important;
    }

   :global(.splide__arrow.custom-arrow) {
      height: 150px;
      width: 70px;
      background-color: transparent;
   }

   :global(.splide__arrow.custom-arrow svg) {
      height: 100%;
      width: 100%;
      fill: white;
   }

   @media screen and (max-width: 768px){
      :global(.splide__arrow.custom-arrow) {
         display: none;
      }
   }

   .image-slider-box {
      max-width: 800px;
      margin: 0 auto;
   }

</style>